
import React, { useEffect, useState } from 'react';
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import './resources.css'
import logoPng from '../../assets/images/source-png.png';
import logoSvg from '../../assets/images/source-svg.svg';
// import ChartList from './ChartList';
const Resources = () => {

    const [responseInfo, setResourceInfo] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.resourcesInfo,
            })
            .then((response) => {
                const resourcesDoc = response.data.allResourcess.edges[0].node;
                setResourceInfo(resourcesDoc);
            window.scrollTo(0, 0);


            })
            .catch((error) => {
                console.error(error);
            });
    });
    
    return (
        <section style={{ backgroundImage: 'url(' + responseInfo?.section_bg?.url + ')' }} className="pattern chart-container">
            <div className="container">
                <h5 className="section-title"> {responseInfo?.title}</h5>
                <h3 className="subtitle ">{responseInfo?.subtitle}</h3>

                <div className="row g-5">
                    <div className="col-md-6 ">
                        <div className="  resource-box ">
                            <h5>{responseInfo?.logo_text}</h5>
                            <div style={{ height: "320px" }} className="d-flex justify-content-center align-items-center">
                                <img src={responseInfo?.logo_img?.url} className="img-fluid" alt="" />
                            </div>
                            <div className="d-flex flex-column flex-lg-row  justify-content-between">
                                <a href={logoSvg} download="logo-svg"> <button href={logoSvg} download="logo-svg" className="primary-btn mb-2  mb-lg-0 px-5">{responseInfo?.svg_text[0].text}</button></a>
                                <a href={logoPng} download="logo-png">   <button className="primary-outline-btn    px-5">{responseInfo?.png_text}</button></a>
                            </div>
                        </div>
                    </div>
                    <div className=" col-md-6   resource-box">
                        <div >
                            <h5>{responseInfo?.brand_text}</h5>
                            <p>Please fill out the form to receive access of the complete brand library.</p>
                        </div>
                        <form>
                            <div className="mb-3">
                                <input type="email" placeholder="Name" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                            </div>
                            <div className="mb-3">
                                <input type="email" placeholder="Email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                            </div>
                            <div className="mb-3">
                                <textarea className="form-control" placeholder="Reason for accessing  ARTPARK brand resources" id="exampleFormControlTextarea1" rows="4"></textarea>
                            </div>

                            <div className="mb-3 form-check ps-0">

                                <div className=" d-flex pt-2 ">
                                    <a target="_blank" href={`mailto: ${responseInfo?.req_link}`} className="primary-btn text-decoration-none  px-5 ">{responseInfo?.req_btn_text}</a>

                                </div>

                            </div>
                        </form>
                    </div>
                </div>

            </div>

        </section>
    );
};

export default Resources;